<div
  class="ui-file-upload"
  [class.ui-file-upload--invalid]="invalid()"
  [class.ui-file-upload--disabled]="disabled()"
  [class.ui-file-upload--readonly]="readonly()"
>
  @if (showLabel()) {
    <div class="ui-file-upload__header">
      <label class="ui-file-upload__label" [attr.for]="resolvedId()">
        {{ label() }}
      </label>
      @if (showRequirement()) {
        <span class="ui-file-upload__requirement" aria-hidden="true">
          {{ requirementText() }}
        </span>
      }
    </div>
  }

  @if (showDropzone()) {
    <div
      class="ui-file-upload__dropzone"
      [class.ui-file-upload__dropzone--drag]="isDragOver()"
      role="button"
      [attr.tabindex]="isInteractive() ? 0 : -1"
      [attr.aria-disabled]="!isInteractive()"
      [attr.aria-label]="placeholder()"
      (click)="openPicker()"
      (keydown)="onKeydown($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      <span class="ui-file-upload__dropzone-icon" aria-hidden="true">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 15V4M12 4l-4 4M12 4l4 4"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 15v3a2 2 0 002 2h12a2 2 0 002-2v-3"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <div class="ui-file-upload__dropzone-text">
        <p class="ui-file-upload__dropzone-primary">{{ placeholder() }}</p>
        <p class="ui-file-upload__dropzone-hint">{{ acceptSummary() }}</p>
      </div>
      <button
        type="button"
        class="ui-file-upload__browse"
        [disabled]="!isInteractive()"
        (click)="openPicker(); $event.stopPropagation()"
      >
        {{ browseLabel() }}
      </button>

      <input
        #fileInput
        class="ui-file-upload__native"
        type="file"
        [id]="resolvedId()"
        [accept]="nativeAccept()"
        [multiple]="multiple()"
        (change)="onFileInput($event)"
      />
    </div>
  }

  @if (listedFiles().length > 0) {
    <ul class="ui-file-upload__list">
      @for (file of listedFiles(); track file.id) {
        <li class="ui-file-upload__item">
          <img
            class="ui-file-upload__item-icon"
            [src]="iconFor(file.extension)"
            alt=""
            width="20"
            height="20"
            aria-hidden="true"
          />

          <div class="ui-file-upload__item-meta">
            <span class="ui-file-upload__item-name" [title]="file.name">{{ file.name }}</span>
            <span class="ui-file-upload__item-size">{{ formatSize(file.size) }}</span>
          </div>

          <div class="ui-file-upload__item-actions">
            @if (file.url) {
              <button
                type="button"
                class="ui-file-upload__action"
                aria-label="Ver archivo"
                (click)="onListedView(file, $event)"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                  <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
                </svg>
              </button>
            }
            @if (file.removable) {
              <button
                type="button"
                class="ui-file-upload__action ui-file-upload__action--danger"
                aria-label="Eliminar archivo"
                [disabled]="!isInteractive()"
                (click)="onListedRemove(file, $event)"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 002 2h6a2 2 0 002-2l1-12M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            }
          </div>
        </li>
      }
    </ul>
  }

  @if (showMessage() && message()) {
    <p
      class="ui-file-upload__message"
      [class.ui-file-upload__message--error]="invalid()"
    >
      {{ message() }}
    </p>
  }
</div>

<ui-loading-modal
  [open]="removeConfirmOpen()"
  variant="warning"
  title="Eliminar archivo"
  message="¿Eliminar el archivo?"
  confirmLabel="Confirmar"
  [showButton]="true"
  [confirmDanger]="true"
  [showCancelButton]="true"
  cancelLabel="Cancelar"
  [blockUi]="true"
  (closed)="onRemoveConfirm()"
  (cancelClicked)="onRemoveCancel()"
/>
